<template>
  <bk-view class="billCodeInfo-container">
    <bk-view class="view-leftInfo">
			<bk-view class="view-item">
				<bk-lang code="appointment_updateCalendar_apptCode" suffix="："></bk-lang>
				<span>{{ reserveInfo.reserveNo }}</span>
			</bk-view>
			<bk-view class="view-item" v-if="reserveInfo.billInfo">
				<bk-lang code="appointment_updateCalendar_billCode" suffix="："></bk-lang>
				<span>{{ reserveInfo.billInfo.billNo }}</span>
			</bk-view>
    </bk-view>
  </bk-view>
</template>

<script>
	
	export default {
		name:'billCodeInfo',
		props:{
			reserveInfo:Object,
			editable:Boolean,
		},
	};
</script>

<style lang="less" scoped>
@import './billCodeInfo.less';
</style>